export class AdvisingAbnormalDialogItemFile {
  fileName: string | null;
  fileExtension: string | null;
  fileType: string | null;
  fileDataUrl: string | null;

  constructor() {
    this.fileName = null;
    this.fileExtension = null;
    this.fileType = null;
    this.fileDataUrl = null;
  }
}
